module.exports = __webpack_public_path__ + "static/img/drawing.b3cdd1f1.png";